
    <label for="{{id}}" *ngIf="label" class="cm-upload-button-label">
      {{label}}
    </label>
    <label for="{{id}}" class="cm-upload-button">
      <input type="file"
             [id]="id" #fileInput
             (change)="handleFileInput($event.target.files)">
    </label>
  